import { defineStore } from 'pinia'

const initialPagination = { current: 1, total_pages: 1, total: 1, per_page: 6 }

const initialState = {
	loading: false,
	tickets: [] as Array<any>,
	pagination: initialPagination,
	showModalLogin: false,
	showModalSignUp: false,
}

/**
 * Pinia store for the authenticated user's scanned/manual ticket list (scan history).
 * Supports paginated fetching by ticket status and saving new tickets.
 */
export const useUserLotteryStore = defineStore('user-lottery', {
	state: () => ({ ...initialState }),
	getters: {},
	actions: {
		/** Sets any top-level state property by key. */
		SET_STATE_LOTTERY({ type, value }: { type: string; value: any }) {
			;(this as any)[type] = value
		},
		/** Saves a new user ticket and returns the API response. */
		async saveLottery(payload: any) {
			const { $repository } = useNuxtApp()
			this.loading = true
			const response = await $repository.v1.userLottery.postLottery(payload)
			this.loading = false
			if (response.success === false) return response

			return response
		},
		/** Fetches a page of user tickets filtered by status and updates `tickets` and `pagination`. */
		async fetchLotteriesByStatus(params: any) {
			const { $repository } = useNuxtApp()
			this.loading = true
			const response = await $repository.v1.userLottery.getLotteriesByStatus(params)
			this.loading = false
			if (response.success === false) {
				this.tickets = []
				this.pagination = initialPagination
				return response
			}
			const { meta, data } = response.result
			this.tickets = data
			this.pagination = {
				current: meta?.current_page || 1,
				total_pages: meta?.last_page || 1,
				total: meta?.total || 1,
				per_page: meta?.per_page || 6,
			}
			return response
		},
	},
})
